import { NgModule } from '@angular/core';
import { Routes, RouterModule, NoPreloading } from '@angular/router';
import { mk } from 'date-fns/locale';

import { AuthGuardGuard } from './auth-guard.guard'


export const AppRoutes: Routes = [
  { path: 'home', 
  // component: HomeComponent 
  loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
},
  { path: 'sitemap', 
  // component: sitemapComponent 
  loadChildren: () => import('./sitemap/sitemap.module').then(m => m.SitemapModule)
},
  { path: 'wish/:item', 
//  component: WishlistComponent, canActivate: [AuthGuardGuard] 
loadChildren: () => import('./wishlist/wishlist.module').then(m => m.wishlistModule)
},
  { path: 'rfqlist/:item/:rfqid',
  // component: RfqlistComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./rfqlist/rfqlist.module').then(m => m.rfqlistModule)
  },
  { path: 'rfqlist', 
  // component: RfqlistComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./rfqlist/rfqlist.module').then(m => m.rfqlistModule)
},  
  { path: 'rma/:item/:rfqid', 
//  component: rmaComponent, canActivate: [AuthGuardGuard] 
loadChildren: () => import('./rma/rma.module').then(m => m.rmaModule)
},
  { path: 'rma',
  // component: rmaComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./rma/rma.module').then(m => m.rmaModule)
},  
  { path: 'login/:customerId/:userId/:password', 
  //component: LoginComponent 
  loadChildren: () => import('./login/login.module').then(m => m.loginModule)
},
  { path: 'wish', 
  // component: WishlistComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./wishlist/wishlist.module').then(m => m.wishlistModule)
},
  { path: 'advancesearch', 
 // component: AdvancesearchComponent, canActivate: [AuthGuardGuard] 
 loadChildren: () => import('./advancesearch/advancesearch.module').then(m => m.advancesearchModule)
},
  { path: 'productlisting', 
//  component: MajProdComponent 
loadChildren: () => import('./maj-prod/MajProd.module').then(m => m.MajProdModule)
},
  { path: 'addyourcard/:id/:ctype',
  // component: AddyourcardComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./addyourcard/addyourcard.module').then(m => m.addyourcardModule)
},
  { path: 'addyourcard/:id/:type/:amount/:ctype', 
//  component: AddyourcardComponent, canActivate: [AuthGuardGuard] 
loadChildren: () => import('./addyourcard/addyourcard.module').then(m => m.addyourcardModule)
},
  { path: 'products/:productName',
  // component: ProductComponent
  loadChildren: () => import('./product/product.module').then(m => m.productModule)
   },
  { path: 'products/:productName/:desc', 
//  component: ProductComponent 
loadChildren: () => import('./product/product.module').then(m => m.productModule)
},
  { path: 'productlist/:satanga', 
  //component: ProductComponent 
  loadChildren: () => import('./product/product.module').then(m => m.productModule)
},
  { path: 'product', 
  // component: CategoryComponent 
  loadChildren: () => import('./category/category.module').then(m => m.categoryModule)
},
  { path: 'allcategory', 
  //component: AllCategoryComponent
  loadChildren: () => import('./all-category/all-category.module').then(m => m.allcategoryModule)
 },
  { path: 'product/:name/:desc', 
  // component: CategoryComponent 
  loadChildren: () => import('./category/category.module').then(m => m.categoryModule)
},
  { path: 'product/:name',
  // component: CategoryComponent 
  loadChildren: () => import('./category/category.module').then(m => m.categoryModule)
},
  { path: 'category/:category/:desc', 
  // component: ProductComponent 
  loadChildren: () => import('./product/product.module').then(m => m.productModule)
},
  { path: 'category/:category',
  // component: ProductComponent 
  loadChildren: () => import('./product/product.module').then(m => m.productModule)
},
  { path: 'search/:searchtext', 
  // component: ProductComponent 
  loadChildren: () => import('./product/product.module').then(m => m.productModule)
},
  { path: 'asearch/:asearch', canActivate: [AuthGuardGuard] ,
  // component: ProductComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./product/product.module').then(m => m.productModule)
},
  { path: 'contact', 
  // component: ContactComponent 
  loadChildren: () => import('./contact/contact.module').then(m => m.contactModule)
},
  { path: 'viewcart', 
  // component: CartPreviewComponent 
  loadChildren: () => import('./cart-preview/cart-preview.module').then(m => m.CartPreviewModule)
},
  { path: 'productdetail/:item', 
  // component: ProductDetailComponent 
  loadChildren: () => import('./product-detail/product-detail.module').then(m => m.ProductDetailModule)
},
  { path: 'productdetail/:item/:desc',
  // component: ProductDetailComponent 
  loadChildren: () => import('./product-detail/product-detail.module').then(m => m.ProductDetailModule)
},
  { path: 'info/:id/:desc',
  // component: infopageComponent
  loadChildren: () => import('./infopage/infopage.module').then(m => m.infopageModule)
 },
  { path: 'info/:id',
  // component: infopageComponent 
  loadChildren: () => import('./infopage/infopage.module').then(m => m.infopageModule)
},
  { path: 'b2b-registration',
  // component: B2bRegistrationComponent 
  loadChildren: () => import('./b2b-registration/b2b-registration.module').then(m => m.b2bregistrationModule)
},
  { path: 'registration',
  // component: B2cRegistrationComponent 
  loadChildren: () => import('./b2c-registration/b2c-registration.module').then(m => m.b2cregistrationModule)
},
  { path: 'login', 
  // component: LoginComponent 
  loadChildren: () => import('./login/login.module').then(m => m.loginModule)
},
  { path: '404', 
  // component: NotFoundComponent 
  loadChildren: () => import('./not-found/not-found.module').then(m => m.notfoundModule)
},  
  { path: 'login/:customerId/:userId/:password', 
  // component: LoginComponent  
  loadChildren: () => import('./login/login.module').then(m => m.loginModule)
},
  { path: 'login/:customerId/:password/:type/:custtype', 
  // component: LoginComponent 
  loadChildren: () => import('./login/login.module').then(m => m.loginModule)
},
  { path: 'sales-login',
  // component: SalesLoginComponent 
  loadChildren: () => import('./sales-login/sales-login.module').then(m => m.salesloginModule)
},
  { path: 'dashboard', canActivate: [AuthGuardGuard],
//  component: DashboardComponent, canActivate: [AuthGuardGuard] 
loadChildren: () => import('./dashboard/dashboard.module').then(m => m.dashboardModule)
},
{ path: 'kinterdashboard', canActivate: [AuthGuardGuard],
//  component: DashboardComponent, canActivate: [AuthGuardGuard] 
loadChildren: () => import('./kinterdashboard/kinterdashboard.module').then(m => m.KinterdashboardModule)
},
  { path: 'userprofile', canActivate: [AuthGuardGuard],
  // component: userprofileComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./userprofile/userprofile.module').then(m => m.userprofileModule)
},
  { path: 'user', canActivate: [AuthGuardGuard],
  // component: UserComponent, canActivate: [AuthGuardGuard] 
  loadChildren: () => import('./user/user.module').then(m => m.userModule)
},
  { path: 'southerquote/:buyercookie', 
  // component: SouthernQuotesComponent 
  loadChildren: () => import('./southern-quotes/southern-quotes.module').then(m => m.southernquotesModule)
},
  {
      path: 'order-management', canActivate: [AuthGuardGuard],
      loadChildren: () => import('./order-management/order-management.module').then(m => m.ordermanagementModule),
      // component: OrderManagementComponent,
//         children: [
//           { path: 'pending-order',  canActivate: [AuthGuardGuard],
// loadChildren: () => import('../app/order-management/pending-order/pending-order.module').then(m => m.pendingorderModule)
//  },
//  { path: 'open-shipment',  canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/open-shipment/open-shipment.module').then(m => m.openshipmentModule)
//  },
//  { path: 'back-orders', canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/back-orders/back-orders.module').then(m => m.backordersModule)
//  },
//  { path: 'invoices', canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/invoices/invoices.module').then(m => m.invoicesModule)
//  },
//  { path: 'order-history',  canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/order-history/order-history.module').then(m => m.orderhistoryModule)
//  },
//  { path: 'purchase-history', canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/purchase-history/purchase-history.module').then(m => m.purchasehistoryModule)
//  },
//  { path: 'customer-products', canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/customer-products/customer-products.module').then(m => m.customerproductsModule)
//  },
//  { path: 'helpdesk',  canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/help-desk/help-desk.module').then(m => m.helpdeskModule)
//  },
//  { path: 'order-view/:id/:type/:rec_type', canActivate: [AuthGuardGuard],
//  loadChildren: () => import('../app/order-management/order-view/order-view.module').then(m => m.orderviewModule)
// },
// { path: 'invoice-payment/:orderno/:seq',canActivate: [AuthGuardGuard],
// loadChildren: () => import('../app/order-management/invoice-payment/invoice-payment.module').then(m => m.invoicepaymentModule)
// }
      //     { path: 'pending-order', component: PendingOrderComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'open-shipment', component: OpenShipmentComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'back-orders', component: BackOrdersComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'order-history', component: OrderHistoryComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'purchase-history', component: PurchaseHistoryComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'customer-products', component: CustomerProductsComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'helpdesk', component: HelpDeskComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'order-view/:id/:type/:rec_type', component: OrderViewComponent, canActivate: [AuthGuardGuard] },
      //     { path: 'invoice-payment/:orderno/:seq', component: InvoicePaymentComponent, canActivate: [AuthGuardGuard] },
      // ]
  },
  { path: 'checkout',
  // component: CheckoutComponent
  loadChildren: () => import('./checkout/checkout.module').then(m => m.checkoutModule)
},
  { path: 'shipping-address/:shipid/:type',
   // component: ShippingAddressComponent,
   
    canActivate: [AuthGuardGuard],
    loadChildren: () => import('./shipping-address/shipping-address.module').then(m => m.shippingaddressModule)

   },
  { path: 'categories',
  // component: AllCategoryComponent 
  loadChildren: () => import('./all-category/all-category.module').then(m => m.allcategoryModule)
},
  { path: 'categories/:name/:desc', 
  //component: AllCategoryComponent 
  loadChildren: () => import('./all-category/all-category.module').then(m => m.allcategoryModule)
},
  { path: 'categories/:name',
  // component: AllCategoryComponent 
  loadChildren: () => import('./all-category/all-category.module').then(m => m.allcategoryModule)
},
  { path: 'review-order', 
  // component: ReviewOrderComponent
  loadChildren: () => import('./review-order/review-order.module').then(m => m.revieworderModule)
},
  { path: 'review-order/:type',
  // component: ReviewOrderComponent
  loadChildren: () => import('./review-order/review-order.module').then(m => m.revieworderModule)
},
  { path: 'changepwd',
  // component: ChangepwdComponent, 
   canActivate: [AuthGuardGuard],
   loadChildren: () => import('./changepwd/changepwd.module').then(m => m.changepwdModule)
   },
  { path: 'pending-order-review', 
   // component: PendingOrderReviewComponent, 
   canActivate: [AuthGuardGuard],
   loadChildren: () => import('./pending-order-review/pending-order-review.module').then(m => m.pendingorderreviewModule)

   },
  { path: 'new-customer',
  // component: NewCustomersComponent 
  loadChildren: () => import('./new-customers/new-customers.module').then(m => m.newcustomersModule)
},
  { path: 'quickadd', 
  // component: QuickOrderPadComponent
  loadChildren: () => import('./quick-order-pad/quick-order-pad.module').then(m => m.QuickOrderPadModule)
 },
   { path: '', 
   // component:defaultredirectComponent, 
   pathMatch: 'full',
   loadChildren: () => import('./default-redirect/default-redirect.module').then(m => m.defaultredirectModule)
   },  
   { path: '**', 
   //component: defaultredirectComponent
   loadChildren: () => import('./default-redirect/default-redirect.module').then(m => m.defaultredirectModule)
   }
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes, {
    onSameUrlNavigation: 'reload',
    preloadingStrategy: NoPreloading,
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
